// extracted by mini-css-extract-plugin
export default {"PrincipalContainer":"Services_PrincipalContainer__CL8+t","ArticleContainer":"Services_ArticleContainer__oLygH","Services":"Services_Services__B6Agi"};